<template>
  <tr v-if="registration.team" class="w-full text-main-text  md:border-b">
    <td class="w-8 text-brand-light font-bold"></td>
    <td>{{ team_position }}</td>
    <td @mousedown="overflowTumbler" @mouseup="overflowTumbler" @mouseout="endOverflow" @click="info"
        class="max-w-2xxs lg:truncate whitespace-normal pr-8 lg:whitespace-no-wrap rounded" field="canAbs">
      <p class="break-all whitespace-normal lg:break-words" :class="isSearched('name')? 'bg-brand-pink-light':''">
        {{ registration.team.name }}</p>
    </td>
    <td v-if="event.results_filled" class="text-center">
      <p v-if="registration.game_result !== 0">{{ registration.game_result }}</p>
      <p class="text-brand-light font-semibold" v-if="registration.game_result === 0">{{ registration.game_result }}</p>
    </td>
    <td class="table-cell" v-if="worksWithPrivileged">
      <div class=" mr-3 my-2">
        <label class="">
                <span class="flex justify-center">
                    <input class="checkbox" @click.prevent="addSelect" :checked="form.is_privileged" type="checkbox">
                    <span class="checkbox-custom" :class="form.is_privileged? 'checkedBut' : ''"></span>
                </span>
        </label>
      </div>
    </td>
    <td class="text-center">
      <div v-if="registration.promocode_discount" class="flex flex-row">
        <p class="lg:w-1/2">{{ getTotalCost }} {{ currencySign }}</p>
        <img @mouseover="switchPopper" @mouseleave="switchPopper" class="ml-1 z-10" src="@/assets/SVG/discount.svg" alt="" ref="discount">
      </div>
      <p v-else>{{ getTotalCost }} {{ currencySign }}</p>
      <div class="absolute rounded-sm shadow-md p-2 bg-white mt-2 w-128"
           style="transform: translateX(2.5rem); z-index: 100;border: 0.5px solid #DADADA;"
           v-if="show_discount_popper && registration.promocode_discount" ref="elements">
        <p>Команда применила промокод <span class="font-bold">{{registration.promocode}}</span> на скидку -{{registration.promocode_discount}}%</p>
      </div>
    </td>
    <td class="text-center">
      {{ registration.player_count }}
    </td>
    <td class="table-cell text-center w-8" >
      <moz-input class="-mt-4 md:-mt-2"
                 type="number"
                 v-model="form.actual_payable_player_count"
                 placeholder=""
                 :max="maxPlayerCount"
                 :min="0"
                 :minHeight="25"
                 inputClasses="text-center max-w-8 font-normal"
                 :key="playerCountKey"
                 :readonly="this.user.role === 'event_organizer'">
      </moz-input>
    </td>

    <td class="table-cell text-center w-8">
      <moz-input class="-mt-4 md:-mt-2"
                 type="number"
                 v-model="form.actual_free_player_count"
                 placeholder=""
                 :max="maxPlayerCount"
                 :min="0"
                 :minHeight="25"
                 inputClasses="text-center max-w-8 font-normal"
                 :key="playerCountKey"
                 :readonly="this.user.role === 'event_organizer'">
      </moz-input>
    </td>


    <!--      discount   -->
    <td class="table-cell">
      <CustomSelect
          :options="discountOptions"
          v-model="form.discount"
          :showArrowDown="true"
          :value="form.discount"
          :noBorder="true"
          :colors="{bgColorHover:'#bd006c',bgColorSelected:'#bd006c'}"
          class="w-16 mx-auto"
      >
      </CustomSelect>
    </td>

    <!--      <td class="table-cell"></td>-->
    <td class="hide-element px-0">
      <div class="flex justify-end relative h-full">
        <on-click-outside :do="hideDotesMenu">
          <img src="@/assets/SVG/dotes-menu.svg" class="h-6 w-6 cursor-pointer"
               :class="dotes_menu_active? 'dotes-menu-active' : 'dotes-menu'"
               @click="dotes_menu_active = !dotes_menu_active">
        </on-click-outside>
        <div v-if="dotes_menu_active"
             class="pl-4 pr-20 py-2 bg-white shadow-mozgo-2 rounded-lg absolute pin-t pin-r mt-10 z-20 lg:whitespace-no-wrap">
          <p @click="team_description_modal=true" class="cursor-pointer">Узнать подробнее </p>
        </div>
      </div>
    </td>


    <team-description-modal v-if="team_description_modal"
                            :team='registration'
                            @close="team_description_modal=false">
    </team-description-modal>

  </tr>
  <tr v-else class="w-full text-main-text">
    <td class=""></td>
    <td class=""></td>
    <td @mousedown="overflowTumbler" @mouseup="overflowTumbler" @mouseout="endOverflow"
        class="max-w-2xxs white-space-normal break-all lg:truncate md:pr-8 lg:whitespace-no-wrap rounded"
        field="canAbs">
      <span>Неучтенные игроки*</span>
    </td>
    <td class=""></td>
    <td v-if="worksWithPrivileged" class="md:table-cell"></td>
    <td class="md:table-cell"></td>
    <td class="">
      <moz-input class="-mt-2 w-full md:w-1/2" type="number" v-model="form.actual_payable_player_count"
                 :min="0" :key="playerCountKey" :readonly="this.user.role === 'event_organizer'"
                 placeholder=""
                 inputClasses="font-normal text-center"
      ></moz-input>
    </td>
    <td>
      <moz-input class="-mt-2 w-full md:w-1/2 font-normal" type="number" v-model="form.actual_free_player_count"
                 :min="0" :key="playerCountKey" :readonly="this.user.role === 'event_organizer'"
                 inputClasses="font-normal text-center"
                 placeholder=""
      ></moz-input>
    </td>


  </tr>
</template>

<script>
import Form from 'form-backend-validation';
import CustomSelect from '@/views/home-page-layouts/paymentModals/CustomSelect.vue';
import OnClickOutside from '@/views/OnClickOutside';
import TeamDescriptionModal from '../team-description-modal';
import {mapState} from 'vuex';
import Popper from "popper.js";

const uuidv4 = require('uuid/v4');

export default {
  name: 'filial-stat-line',
  props: ['registration', 'team_count', 'checkedLine', 'gameType', 'product', 'worksWithPrivileged', 'event', 'city'],
  components: {OnClickOutside, TeamDescriptionModal, CustomSelect},
  data() {
    return {
      form: new Form({
        actual_player_count: this.registration.actual_player_count === 0 ? this.registration.actual_player_count : (this.registration.actual_player_count || null),
        actual_free_player_count: this.registration.actual_free_player_count === 0 ? this.registration.actual_free_player_count : (this.registration.actual_free_player_count || 0),
        actual_payable_player_count: this.registration.actual_payable_player_count === 0 ? this.registration.actual_payable_player_count : (this.registration.actual_payable_player_count || null),
        unaccounted_team_count: this.registration.unaccounted_team_count === 0 ? this.registration.unaccounted_team_count : (this.registration.unaccounted_team_count || null),
        is_privileged: this.registration.is_privileged,
        discount: this.registration.discount || 0,
      }),
      maxPlayerCount: 20,
      maxTeamCount: 0,
      playerCountKey: uuidv4(),
      teamCountKey: uuidv4(),
      dotes_menu_active: false,
      team_description_modal: false,
      discountOptions: [
        {id: 0, value: 0},
        {id: 1, value: 30},
        {id: 2, value: 50},
        {id: 3, value: 90},
        {id: 4, value: 100},
      ],
      show_discount_popper: false,
    };
  },
  mounted() {
    // тут проходим по всей строке и выставляем поинтеры
    const elem = this.$el;
    [...elem.children].forEach((element) => {
      if ((element.scrollWidth > element.clientWidth) && element.getAttribute('field') === 'canAbs') {
        element.classList.toggle('cursor-pointer');
      }
    });
  },
  methods: {
    overflowTumbler(event) {
      const target = event.target.parentElement;
      const isOverflow = target.scrollWidth > target.clientWidth;
      if (target.getAttribute('field') === 'canAbs' && (isOverflow || target.classList.contains('exp'))) {
        if ((event.type === 'mouseup') && isOverflow) return;
        target.classList.toggle('truncate');
        target.classList.toggle('absolute');
        target.classList.toggle('border');
        target.classList.toggle('bg-white');
        target.classList.toggle('fit_content');
        target.classList.toggle('exp');
      }
    },
    endOverflow(event) {
      const target = event.target.parentElement;
      if (target.getAttribute('field') === 'canAbs' && (target.classList.contains('exp'))) {
        target.classList.toggle('truncate');
        target.classList.toggle('absolute');
        target.classList.toggle('border');
        target.classList.toggle('bg-white');
        target.classList.toggle('fit_content');
        target.classList.toggle('exp');
      }
    },
    isSearched(field) {
      if (!this.$route.query.like) return false;
      const fieldNamesArray = field.split('.');
      const rootObj = this.registration.team;
      const lastObj = fieldNamesArray.reduce((acc, field) => acc[field], rootObj);
      if (!lastObj) return false;
      return !!lastObj.toLowerCase().includes(this.$route.query.like.toLowerCase());
    },
    addSelect() {
      this.form.is_privileged = !this.form.is_privileged;
    },

    hideDotesMenu() {
      this.dotes_menu_active = false;
    },
    info() {
      if (this.mobile) {
        this.$router.push({
          name: 'info',
          params: {
            team: this.registration.team.name,
            teamObject: this.registration.team,
            playerCount: this.registration.player_count,
            totalCost: this.registration.total_cost,
            comment: this.registration.comment,
            event: this.event,
            type: 'stat',
            registrationId: this.registration.id,
          },
        });
      }
    },
    switchPopper() {
      this.show_discount_popper = !this.show_discount_popper;
      if (this.show_discount_popper) {
        this.$nextTick(() => {
          this.setupPopper();
        });
      }
    },
    setupPopper() {
      if (this.popper === undefined) {
        this.popper = new Popper(this.$refs.discount, this.$refs.elements, {
          placement: 'bottom-end',
        });
      } else {
        this.popper.scheduleUpdate();
      }
    },
  },
  computed: {
    ...mapState({
      currency: state => state.auth.user.currency,
      user: state => state.auth.user,
    }),
    currencySign() {
      return this.currency === 'RUB' ? '₽' : '';
    },
    mobile() {
      return window.innerWidth < 840;
    },
    team_position() {
      return this.team_count + 1;
    },
    searched() {
      if (!this.$route.query.like) return false;
      return !!this.registration.team.name.toLowerCase().includes(this.$route.query.like.toLowerCase());
    },
    getTotalCost() {
      if (this.registration.player_count && !this.registration.actual_payable_player_count) {
        const totalCostWithOutDiscount = this.registration.player_count * (this.event.price / 100);
        return totalCostWithOutDiscount - (totalCostWithOutDiscount * (this.form.discount / 100));
      }
      const totalCostWithOutDiscount = this.registration.actual_payable_player_count * (this.event.price / 100);
      return totalCostWithOutDiscount - (totalCostWithOutDiscount * (this.form.discount / 100));
    },
  },
  watch: {
    form: {
      deep: true,
      handler(value) {
        if (this.registration.team) {
          if (value.actual_free_player_count || value.actual_payable_player_count) {
            if (value.actual_free_player_count > this.maxPlayerCount) {
              this.$set(this.form, 'actual_free_player_count', this.maxPlayerCount);
              this.playerCountKey = uuidv4();
            }
            if (value.actual_payable_player_count > this.maxPlayerCount) {
              this.$set(this.form, 'actual_payable_player_count', this.maxPlayerCount);
              this.playerCountKey = uuidv4();
            }
          } else if (value.actual_player_count > this.maxPlayerCount) {
            this.$set(this.form, 'actual_player_count', this.maxPlayerCount);
            this.playerCountKey = uuidv4();
          }
          if (value.unaccounted_team_count > this.maxTeamCount) {
            this.$set(this.form, 'unaccounted_team_count', this.maxTeamCount);
            this.teamCountKey = uuidv4();
          }
        }
        this.$set(this.form, 'actual_player_count', (this.form.actual_payable_player_count ? parseInt(this.form.actual_payable_player_count) : 0) + (this.form.actual_free_player_count ? parseInt(this.form.actual_free_player_count) : 0));

        this.$emit('player_count_change', {
          id: this.registration.id,
          actual_player_count: this.form.actual_player_count,
          actual_free_player_count: this.form.actual_free_player_count,
          actual_payable_player_count: this.form.actual_payable_player_count,
          unaccounted_team_count: this.form.unaccounted_team_count,
          is_privileged: this.form.is_privileged,
          discount: this.form.discount,
        });
      },
    },
    beforeDestroy() {
      if (this.popper) {
        this.popper.destroy();
      }
    },
  },
};
</script>

<style scoped>

.checkbox {
  display: none;
}

.checkbox-custom {
  position: relative;
  width: 16px;
  height: 16px;
  border: 1px solid #979797;
  border-radius: 2px;

}

.checkbox-custom,
.label {
  display: inline-block;
  vertical-align: middle;
}

.checkedBut::before {
  content: "";
  display: block;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 92%;
  height: 92%;
  background-color: #bd006c;
  border-radius: 2px;
  border: 1px solid white;
}

.fit_content {
  max-width: fit-content !important;
}

select option:hover {
  box-shadow: 0 0 10px 100px #1882A8 inset;
}

td {
  @apply text-left p-2 font-sans text-sm;
}

.dotes-menu {
  border-radius: 999px;
  transition: background-color 0.5s linear;
}

.dotes-menu-active {
  background-color: #DADADA;
  border-radius: 999px;
}

@media (max-width: 767px) {
  .hide-element {
    display: none !important;
  }
}
</style>
